import {Component, Input} from '@angular/core';

@Component({
  selector: 'ms-alert-widget',
  imports: [],
  templateUrl: './alert-widget.component.html',
  styleUrl: './alert-widget.component.scss'
})
export class AlertWidgetComponent {
  @Input() title: string = '';
  @Input() alerts: Array<{ date: string; version: string; changes: string[]; }> = [];

  constructor() {
  }
}
